import { render, staticRenderFns } from "./Guides.vue?vue&type=template&id=0cf1ae01&scoped=true"
import script from "./Guides.vue?vue&type=script&setup=true&lang=js"
export * from "./Guides.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Guides.vue?vue&type=style&index=0&id=0cf1ae01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf1ae01",
  null
  
)

export default component.exports